import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined } from "@ant-design/icons";
import { StaffPermission } from "@hooks/usePermission";

// 廠商類別
export enum VendorCategory {
  COMPANY = 1, // 公司戶
  PERSONAL = 2, // 個人戶
}

export const vendorCategoryMap: Record<VendorCategory, string> = {
  [VendorCategory.COMPANY]: "公司戶",
  [VendorCategory.PERSONAL]: "個人戶",
};

// 廠商申請狀態
export enum VendorApplicationStatus {
  PENDING_REVIEW = 1, // 待審核
  MANAGER_REJECTED = 2, // 主管駁回
  PENDING_FILING = 3, // 待建檔
  FINANCE_REJECTED = 4, // 財務退回
  PENDING_SYNC = 5, // 待系統同步
  COMPLETED = 6, // 已完成
}

export const vendorApplicationStatusMap: Record<VendorApplicationStatus, string> = {
  [VendorApplicationStatus.PENDING_REVIEW]: "待主管審核",
  [VendorApplicationStatus.MANAGER_REJECTED]: "主管駁回",
  [VendorApplicationStatus.PENDING_FILING]: "待財務建檔",
  [VendorApplicationStatus.FINANCE_REJECTED]: "財務退回",
  [VendorApplicationStatus.PENDING_SYNC]: "待系統同步",
  [VendorApplicationStatus.COMPLETED]: "已完成",
};

// 權限對應表 -> 狀態：可審核權限
export const permissionMap: Record<number, StaffPermission> = {
  [VendorApplicationStatus.PENDING_REVIEW]: StaffPermission.VENDOR_MANAGER_APPROVAL,
  [VendorApplicationStatus.PENDING_FILING]: StaffPermission.VENDOR_FINANCE_APPROVAL,
};
// 可編輯基本資訊的狀態
export const EDITABLE_BASIC_STATUSES: number[] = [
  VendorApplicationStatus.MANAGER_REJECTED,
  VendorApplicationStatus.FINANCE_REJECTED,
  VendorApplicationStatus.COMPLETED,
];

// 編輯狀態
export enum EditStatus {
  BASIC = "basic",
  OTHERS = "others",
  VIEW = "view",
}
export const tagMap = {
  [VendorApplicationStatus.PENDING_REVIEW]: {
    color: "processing",
    icon: SyncOutlined,
    text: vendorApplicationStatusMap[VendorApplicationStatus.PENDING_REVIEW],
  },
  [VendorApplicationStatus.MANAGER_REJECTED]: {
    color: "red",
    icon: CloseCircleOutlined,
    text: vendorApplicationStatusMap[VendorApplicationStatus.MANAGER_REJECTED],
  },
  [VendorApplicationStatus.PENDING_FILING]: {
    color: "processing",
    icon: SyncOutlined,
    text: vendorApplicationStatusMap[VendorApplicationStatus.PENDING_FILING],
  },
  [VendorApplicationStatus.FINANCE_REJECTED]: {
    color: "red",
    icon: CloseCircleOutlined,
    text: vendorApplicationStatusMap[VendorApplicationStatus.FINANCE_REJECTED],
  },
  [VendorApplicationStatus.PENDING_SYNC]: {
    color: "warning",
    icon: SyncOutlined,
    text: vendorApplicationStatusMap[VendorApplicationStatus.PENDING_SYNC],
  },
  [VendorApplicationStatus.COMPLETED]: {
    color: "success",
    icon: CheckCircleOutlined,
    text: vendorApplicationStatusMap[VendorApplicationStatus.COMPLETED],
  },
};
